import { createRoot } from "react-dom/client";

import "react-simple-keyboard/build/css/index.css";
import "./index.css";

import App from "./App";
import { store } from "./redux/store";

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<App store={store} />);
